import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

import AppBreadcrumbs from 'Components/Breadcrumbs/AppBreadcrumbs';
import { getTextBreadcrumb } from 'Components/Breadcrumbs/dataUtils';
import FilterSearchColors from 'Components/Mix/FilterSearchColors';
import ResultsItem from 'Components/Results/ResultsItem';
import ErrorMessage from 'Components/UI/ErrorMessage';
import Loading from 'Components/UI/Loading';

import { useAuthState } from 'Context';

import { colorsSelector, setColors } from 'Features/Colors/colorsSlice';
import {
  inProgressSelector,
  setInProgress,
} from 'Features/Filter/inProgressSlice';
import { setPageTitle } from 'Features/Main/mainSlice';
import {
  fetchBuildings,
  resultsSelector,
  setNotError,
} from 'Features/Results/resultsSlice';

import { filterItem } from 'Utils';

export default function Results() {
  const { buildings, isLoading, error } = useSelector(resultsSelector);
  const [search, setSearch] = useState('');
  const { colors } = useSelector(colorsSelector);
  const { inProgress } = useSelector(inProgressSelector);
  const dispatch = useDispatch();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const authState = useAuthState();

  useEffect(() => {
    dispatch(fetchBuildings(colors, null, false, inProgress));
    setBreadcrumbs([getTextBreadcrumb('Portfolio')]);
    dispatch(setPageTitle('Results'));
  }, []);

  useEffect(() => {
    dispatch(fetchBuildings(colors, null, true, inProgress));
  }, [authState.viewCompanyId]);

  const handleFilterChange = useCallback(
    (colorsObj) => {
      dispatch(setColors(colorsObj));
      dispatch(fetchBuildings(colorsObj, null, true, inProgress));
    },
    [colors, inProgress],
  );

  const handleInProgressSwitch = useCallback(
    (inProgressValue) => {
      dispatch(setInProgress(inProgressValue));
      dispatch(fetchBuildings(colors, null, true, inProgressValue));
    },
    [colors],
  );

  const handleCloseErrorAlert = () => {
    dispatch(setNotError());
  };

  let currentPortfolioId = 0;

  return (
    <>
      {!!error && (
        <ErrorMessage
          message={error}
          handleCloseErrorAlert={handleCloseErrorAlert}
        />
      )}
      {!!isLoading && <Loading />}
      <div style={{ width: '100%' }}>
        <AppBreadcrumbs links={breadcrumbs} />
        <div style={{ display: 'flex' }}>
          <div style={{ flexGrow: 1 }}>
            <FilterSearchColors
              filterColors={colors}
              inProgress={inProgress}
              handleSearch={setSearch}
              searchFieldLabel={'Search for Buildings'}
              handleFilterChange={handleFilterChange}
              handleInProgressSwitch={handleInProgressSwitch}
            />
            <div style={{ width: '100%' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexWrap: 'wrap',
                }}
              >
                {!!buildings &&
                  buildings
                    .filter((item) => filterItem(item, search))
                    .map((item, index) => {
                      if (item.portfolioid !== currentPortfolioId) {
                        currentPortfolioId = item.portfolioid;
                        return (
                          <React.Fragment key={`main ${item.buildingid}`}>
                            <Box style={{ marginBottom: 10, width: '100%' }}>
                              <Typography
                                variant="h4"
                                style={{ marginBottom: 10 }}
                              >
                                {item.portfolioname}
                              </Typography>
                            </Box>
                            <Box key={item.buildingid} sx={{ mb: 5, mr: 4 }}>
                              <ResultsItem item={item} index={index} />
                            </Box>
                          </React.Fragment>
                        );
                      } else {
                        return (
                          <Box key={item.buildingid} sx={{ mb: 5, mr: 4 }}>
                            <ResultsItem item={item} index={index} />
                          </Box>
                        );
                      }
                    })}
              </Box>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
